import React from 'react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import { TableHead } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import moment from 'moment';
import { useGetassetReqQuery, useDeleteassetReqMutation } from '../../../../features/assetrequest/assetReqApiSlice'
import useAuth from '../../../../features/hooks/useAuth';
import { useGetUsersQuery } from '../../../../features/users/usersApiSlice';
import { useGetdirectReqQuery } from '../../../../features/directreq/directReqApiSlice'
import { TableContStyle, TableHeadStyle } from '../../../../Styles/TableStyles'
import DownloadIcon from '@mui/icons-material/Download';

const SearchContainer = styled.div`
display: flex;
align-items: flex-end;
align-content: flex-end;
margin: 20px 5px;
`
const StyledButton = styled.button`
width: 100px;
height: 40px;
padding: 5px 7px;
border: none;
border-radius:10px ;
cursor: pointer;
background-color: teal;
`
const NoDataSpan = styled.span`
width:100%;
font-size:20px;
font-weight:300;
margin-left: 20px ;
`
const StatusTextCont = styled('div')(({ type }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 8px', // Adjust padding for proper spacing
    borderRadius: '10px',
    fontSize: '0.875rem', // Ensure text fits within the container
    color: '#000000', // Text color for better readability
    backgroundColor: (() => {
      switch (type) {
        case 'accepted':
          return '#00A700';
        case 'issued':
          return '#A8E591';
        case 'pending':
          return '#FCCB00';
        case 'reject_req':
          return '#EB9D87';
        case 'rejected':
          return '#FB6B6B';
        case 'modify_assets':
          return '#ecb3ff';
        case 'partialissue':
          return '#c6ecc6';
        case 'final':
          return '#40bf80';
        case 'partialissueaccepted':
          return '#b3ff99';
        default:
          return '#d3d3d3'; // Default color for undefined statuses
      }
    })(),
  }));
  
  const styles = {
    tableContainer: {
      backgroundColor: '#f9f9f9',
    },
    tableHead: {
      backgroundColor: '#1976d2',
      color: '#fff',
      fontWeight: 'bold',
      fontSize: '1rem',
    },
    cell: {
      fontSize: '0.875rem',
      textAlign: 'center',
    },
    actionButton: {
      textTransform: 'none',
      backgroundColor: '#1976d2',
      color: '#fff',
      padding: '5px 10px',
    },
  };
  

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function CustomPaginationActionsTable({ handleEditclick }) {

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [selected, setSelected] = React.useState('name');
    const [query, setQuery] = React.useState('');

    const { id, email, designation, designationSuffix, numSuffix, roles } = useAuth()
    let user_current_office = (useSelector((state) => state.office.off))
    let user_current_role_array = roles[user_current_office]

    //all direct req request call
    const {
        data: alldirectReqs,
        isLoading,
        isSuccess,
        isError,
        error

    } = useGetdirectReqQuery('alldirectReqlist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    // allassetreq call
    let tempDirectReqdata = alldirectReqs ? Object.values(alldirectReqs?.entities) : []

    //all request call
    const {
        data: allassetReqs,
    } = useGetassetReqQuery('allassetReqlist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    //usercall
    const { getSingleuser } = useGetUsersQuery('userslist', {
        selectFromResult: ({ data }) => ({
            getSingleuser: data?.entities
        }),
    })

    // delete may be used later
    const [deleteAssetReq, { isLoading: deleteAssetloading }] = useDeleteassetReqMutation()

    // allassetreq call
    let tempdata = allassetReqs ? Object.values(allassetReqs?.entities) : []

    // filter request with store office first (|| is added for the store to store assets transfer requests)
    let officeFilteredreq = tempdata.filter(elm => ((elm.req_store === user_current_office) || (elm.sender_store === user_current_office)))
    // filter reqs if atleast once sent by the assetManagers( level-1 or 2)
    let rows = []

    if (user_current_role_array.includes('level1approver') || user_current_role_array.includes('level2approver')) {
        rows = officeFilteredreq.filter(elm => elm.req_data.filter(elem => (elem.sent_by?.office === user_current_office) && (elem.sent_by?.designation === designation[user_current_office]) && (elem.sent_by?.designationSuffix === designationSuffix[user_current_office]) && (elem.sent_by?.numSuffix === numSuffix[user_current_office])).length > 0)
    } else {
        rows = []
    }

    let filteredrows = rows.filter(row => row[selected]?.toLowerCase().includes(query.toLowerCase()))
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    return (
        // <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}>
        //     {rows.length === 0 ? <NoDataSpan> No document sent by you </NoDataSpan> :
        //         <Table aria-label="custom pagination table">
        //             <TableHead>
        //                 <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor }}>
        //                     <TableCell>SLNo</TableCell>
        //                     <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">ReqID</TableCell>
        //                     <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Type</TableCell>
        //                     <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Category</TableCell>
        //                     <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Created Date</TableCell>
        //                     <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Sent On</TableCell>
        //                     <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Sent to</TableCell>
        //                     <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Currently with</TableCell>
        //                     <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Status</TableCell>
        //                     <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Action</TableCell>
        //                 </TableRow>
        //             </TableHead>
        //             <TableBody>
        //                 {(query ? filteredrows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) :
        //                     rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        //                 ).map((row, index) => (
        //                     < TableRow key={index} >
        //                         <TableCell style={{ width: 5 }} component="th" scope="row">
        //                             {index + 1}
        //                         </TableCell>
        //                         <TableCell style={{ width: 160 }} align="right">
        //                             {row?._id}
        //                         </TableCell>
        //                         <TableCell style={{ width: 160 }} >
        //                             <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        //                                 {row.req_type}
        //                                 {row.req_type === 'direct' && <a href={`http://localhost:5000/directReqFolder/${tempDirectReqdata?.filter(elm => elm.uniqueReqId === row.uniqueReqId)[0]?.fileName}`} target="_blank"
        //                                     rel="noreferrer">
        //                                     <DownloadIcon />
        //                                 </a>}
        //                             </div>
        //                         </TableCell>
        //                         <TableCell style={{ width: 160 }} align="right">
        //                             {row.req_cat}
        //                         </TableCell>
        //                         <TableCell style={{ width: 160 }} align="right">
        //                             {row?.created_at}
        //                         </TableCell>
        //                         <TableCell style={{ width: 160 }} align="right">
        //                             {row?.req_data[row.req_data.findLastIndex(elem => (elem.sent_by.office === user_current_office) && (elem.sent_by.designation === designation[user_current_office]) && (elem.sent_by.designationSuffix === designationSuffix[user_current_office]) && (elem.sent_by.numSuffix === numSuffix[user_current_office]))]?.time_stamp}
        //                         </TableCell>
        //                         <TableCell style={{ width: 160 }} align="right">
        //                             {
        //                                 `${row?.req_data[row.req_data.findLastIndex(elem => (elem.sent_by.office === user_current_office) && (elem.sent_by.designation === designation[user_current_office]) && (elem.sent_by.designationSuffix === designationSuffix[user_current_office]) && (elem.sent_by.numSuffix === numSuffix[user_current_office]))]?.sent_to.name?.firstName} ${row?.req_data[row.req_data.findLastIndex(elem => (elem.sent_by.office === user_current_office) && (elem.sent_by.designation === designation[user_current_office]) && (elem.sent_by.designationSuffix === designationSuffix[user_current_office]) && (elem.sent_by.numSuffix === numSuffix[user_current_office]))]?.sent_to.name?.middleName} ${row?.req_data[row.req_data.findLastIndex(elem => (elem.sent_by.office === user_current_office) && (elem.sent_by.designation === designation[user_current_office]) && (elem.sent_by.designationSuffix === designationSuffix[user_current_office]) && (elem.sent_by.numSuffix === numSuffix[user_current_office]))]?.sent_to.name?.lastName} ${row?.req_data[row.req_data.findLastIndex(elem => (elem.sent_by.office === user_current_office) && (elem.sent_by.designation === designation[user_current_office]) && (elem.sent_by.designationSuffix === designationSuffix[user_current_office]) && (elem.sent_by.numSuffix === numSuffix[user_current_office]))]?.sent_to.office}-${row?.req_data[row.req_data.findLastIndex(elem => (elem.sent_by.office === user_current_office) && (elem.sent_by.designation === designation[user_current_office]) && (elem.sent_by.designationSuffix === designationSuffix[user_current_office]) && (elem.sent_by.numSuffix === numSuffix[user_current_office]))]?.sent_to.designation}-${row?.req_data[row.req_data.findLastIndex(elem => (elem.sent_by.office === user_current_office) && (elem.sent_by.designation === designation[user_current_office]) && (elem.sent_by.designationSuffix === designationSuffix[user_current_office]) && (elem.sent_by.numSuffix === numSuffix[user_current_office]))]?.sent_to.designationSuffix}`
        //                             }
        //                         </TableCell>
        //                         <TableCell style={{ width: 160 }} align="right">
        //                             {`${row?.curr_sent_to?.name?.firstName} ${row?.curr_sent_to?.name?.middleName} ${row?.curr_sent_to?.name?.lastName} ${row?.curr_sent_to?.office}-${row?.curr_sent_to?.designation}-${row?.curr_sent_to?.designationSuffix}`}
        //                         </TableCell>
        //                         <TableCell style={{ width: 160 }} align="right">
        //                             <StatusTextCont type={row.curr_status}>
        //                                 {row.curr_status}
        //                             </StatusTextCont>
        //                         </TableCell>
        //                         <TableCell style={{ width: 160 }} align="right">
        //                             {/* <StyledButton onClick={(e) => handleViewclick(e, 'clicked', row._id)}>View</StyledButton> */}
        //                             <StyledButton onClick={(e) => handleEditclick(e, row._id, row.req_type)}>view</StyledButton>
        //                             {/* <StyledButton onClick={() => handleDeleteButton(row._id)} >Delete</StyledButton> */}
        //                         </TableCell>
        //                     </TableRow>
        //                 ))}
        //                 {emptyRows > 0 && (
        //                     <TableRow style={{ height: 5 * emptyRows }}>
        //                         <TableCell colSpan={6} />
        //                     </TableRow>
        //                 )}
        //             </TableBody>
        //             <TableFooter>
        //                 <TableRow>
        //                     <TablePagination
        //                         rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
        //                         colSpan={8}
        //                         count={rows.length}
        //                         rowsPerPage={rowsPerPage}
        //                         page={page}
        //                         SelectProps={{
        //                             inputProps: {
        //                                 'aria-label': 'rows per page',
        //                             },
        //                             native: true,
        //                         }}
        //                         onPageChange={handleChangePage}
        //                         onRowsPerPageChange={handleChangeRowsPerPage}
        //                         ActionsComponent={TablePaginationActions}
        //                     />
        //                 </TableRow>
        //             </TableFooter>
        //         </Table>}
        // </TableContainer >
        <TableContainer component={Paper} sx={{ ...styles.tableContainer, overflowX: 'auto' }}>
      {rows.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px', fontSize: '1rem', color: '#555' }}>
          No document sent by you
        </div>
      ) : (
        <Table aria-label="custom pagination table" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ ...styles.tableHead, width: '5%', textAlign: 'center' }}>SLNo</TableCell>
              <TableCell sx={{ ...styles.tableHead, width: '15%', textAlign: 'center' }}>ReqID</TableCell>
              <TableCell sx={{ ...styles.tableHead, width: '15%', textAlign: 'center' }}>Type</TableCell>
              <TableCell sx={{ ...styles.tableHead, width: '15%', textAlign: 'center' }}>Category</TableCell>
              <TableCell sx={{ ...styles.tableHead, width: '15%', textAlign: 'center' }}>Sent On</TableCell>
              <TableCell sx={{ ...styles.tableHead, width: '15%', textAlign: 'center' }}>Sent By</TableCell>
              <TableCell sx={{ ...styles.tableHead, width: '10%', textAlign: 'center' }}>Status</TableCell>
              <TableCell sx={{ ...styles.tableHead, width: '10%', textAlign: 'center' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(query ? filteredrows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) :
              rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            ).map((row, index) => (
              <TableRow key={index} hover>
                <TableCell sx={{ ...styles.cell, width: '5%', textAlign: 'center' }}>{index + 1}</TableCell>
                <TableCell
                  sx={{
                    ...styles.cell,
                    width: '15%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textAlign: 'center',
                  }}
                  title={row._id}
                >
                  {row._id}
                </TableCell>
                <TableCell sx={{ ...styles.cell, width: '15%', textAlign: 'center' }}>
                  {row.req_type}
                </TableCell>
                <TableCell sx={{ ...styles.cell, width: '15%', textAlign: 'center' }}>{row.req_cat}</TableCell>
                <TableCell sx={{ ...styles.cell, width: '15%', textAlign: 'center' }}>
                  {row.req_data[row.req_data.length - 1]?.time_stamp}
                </TableCell>
                <TableCell
                  sx={{
                    ...styles.cell,
                    width: '25%',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    textAlign: 'left',
                  }}
                >
                  {row.req_data[row.req_data.length - 1]?.sent_by &&
                    `${row.req_data[row.req_data.length - 1]?.sent_by.name.firstName} 
                ${row.req_data[row.req_data.length - 1]?.sent_by.name.middleName} 
                ${row.req_data[row.req_data.length - 1]?.sent_by.name.lastName} - 
                ${row.req_data[row.req_data.length - 1]?.sent_by.designation} - 
                ${row.req_data[row.req_data.length - 1]?.sent_by.office}`}
                </TableCell>
                <TableCell sx={{ ...styles.cell, width: '10%', textAlign: 'center' }}>
                  <StatusTextCont type={row.curr_status}>{row.curr_status}</StatusTextCont>
                </TableCell>
                <TableCell sx={{ ...styles.cell, width: '10%', textAlign: 'center' }}>
                  <StyledButton
                    sx={styles.actionButton}
                    onClick={(e) => handleEditclick(e, row._id, row.req_type)}
                  >
                    View/Action
                  </StyledButton>
                </TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={8} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                colSpan={8}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    'aria-label': 'rows per page',
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      )}
    </TableContainer>
    )
}
